const captions = {
    ["REG_GDPR_UCET"]: 'Zpracování osobních údajů',
    ["REG_PLNA_MOC_PORTAL"]: 'Plná moc',
    ["REG_PODMINKY_PORTAL"]: 'Podmínky užívání portálu',
};

export function getCaption(value) {
    return captions[value];
}

